import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PixRecipientResponse} from '@gatewee/services';
import {
  formatRecipientAccount,
  formatRecipientAgency,
} from '../withdrawal-pix-recipient.utils';

@Component({
  selector: 'app-withdrawal-step-confirmed',
  templateUrl: './withdrawal-step-confirmed.component.html',
  standalone: false,
})
export class WithdrawalStepConfirmedComponent {
  @Input() pixRecipientResponse: PixRecipientResponse | null = null;
  @Input() resolvedRecipientName = '';
  @Input() confirmedAvatarInitialsSource = '';
  @Input() confirmedBankBadgeLetter = '';
  @Input() confirmedBankDisplayLine = '';
  @Input() hasConfirmedRecipientBankDetails = false;
  @Input() confirmedPixKeyDisplayMode: 'document' | 'phone' | 'plain' = 'plain';
  @Input() confirmedPixKeyDigitsForPipe = '';
  @Input() confirmedPixKeyLine = '';
  @Input() confirmedPixKeyTypeTranslationKey: string | null = null;
  @Input() confirmedPixKeyDisplay = '';

  @Output() readonly backToSearch = new EventEmitter<void>();

  formatAgency = formatRecipientAgency;
  formatAccount = formatRecipientAccount;
}
